import React from 'react'

interface AudioWaveEffectProps {
  className?: string
}

const AudioWaveEffect: React.FC<AudioWaveEffectProps> = ({
  className = '',
}) => {
  const combinedClassName = `w-full h-full ${className}`.trim()

  return (
    <svg
      id="wave"
      width="26"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 32"
      preserveAspectRatio="none"
      strokeWidth="1"
      className={combinedClassName}
    >
      <path
        className="origin-center animate-wave animation-delay-[0.25s]"
        d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"
      />

      <path
        className="origin-center animate-wave animation-delay-[0.5s]"
        d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z"
      />

      <path
        className="origin-center animate-wave animation-delay-[0.75s]"
        d="M12.91,0L12.78,0A1,1,0,0,0,12,1V33.3a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z"
      />

      <path
        className="origin-center animate-wave animation-delay-[1s]"
        d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z"
      />

      <path
        className="origin-center animate-wave animation-delay-[1.25s]"
        d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z"
      />
    </svg>
  )
}

export default AudioWaveEffect
